import React from "react";
import { Card } from "../../../../shared/components/ui/Card";
import { InfoField } from "../../../../shared/components/ui/InfoField";
import type {
  AdverseEventType,
  EventSpecificFactor,
  AdverseEventInterventionLevel,
} from "../../../../api/client/types/catalog.types";

interface AdverseEventNewDetailFieldsProps {
  adverseEventType: AdverseEventType | null;
  spentItems?: string | null;
  eventSpecificFactor?: EventSpecificFactor | null;
  adverseEventInterventionLevel?: AdverseEventInterventionLevel | null;
}

/**
 * AdverseEventNewDetailFields
 * Renders only the adverse event-specific detail fields in read-only format.
 * Designed to be used within a parent detail component that handles common fields.
 */
export const AdverseEventNewDetailFields: React.FC<
  AdverseEventNewDetailFieldsProps
> = ({ adverseEventType, spentItems, eventSpecificFactor, adverseEventInterventionLevel }) => {
  const showFactors = !!(eventSpecificFactor || adverseEventInterventionLevel);

  return (
    <Card variant="formSection">
      <h2 className="text-lg font-medium text-gray-800 mb-4">
        Información de Evento Adverso
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <InfoField
          label="Tipo de Evento Adverso"
          value={adverseEventType?.name}
        />

        {spentItems && (
          <div className="md:col-span-2">
            <InfoField label="Insumos Gastados" value={spentItems} />
          </div>
        )}
      </div>

      {showFactors && (
        <div className="mt-6 pt-6 border-t border-gray-200">
          <h3 className="text-md font-medium text-gray-700 mb-4">
            {`Factores Asociados al ${adverseEventType?.name ?? "Accidente o Incidente"}`}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {eventSpecificFactor?.main_factor && (
              <div className="md:col-span-2">
                <InfoField
                  label="Factor principal asociado"
                  value={eventSpecificFactor.main_factor.name}
                />
              </div>
            )}
            {eventSpecificFactor && (
              <div className="md:col-span-2">
                <InfoField
                  label="Factor específico asociado"
                  value={eventSpecificFactor.name}
                />
              </div>
            )}
            {adverseEventInterventionLevel && (
              <div className="md:col-span-2">
                <InfoField
                  label="Nivel de intervención"
                  value={adverseEventInterventionLevel.name}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </Card>
  );
};
